import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { TableComponent } from "../../Partials/Table/TableComponent";
import { connect } from "react-redux";

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { EventInterface } from "../../../Entity/Entities/Event/EventInterface";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { BankAccountInterface } from "../../../Entity/Entities/BankAccount/BankAccountInterface";
import { BankAccountCreate } from "../../Partials/Dialog/BankAccountCreate";
import { BankAccountUpdate } from "../../Partials/Dialog/BankAccountUpdate";

class BankAccounts extends Component {
  protected selectedBankAccount: BankAccountInterface;
  protected pontoEventTypeId = 47
  public state = {
    isDeleteBankAccountPopupOpen: false,
    currentBankAccount: null,
    isDialogOpen: false,
    isUpdating: false,
    anchorEl: null,
    showPontoDialog: false,
    events: [],
    fetchingEvents: true
  };

  constructor(public props) {
    super(props);

    this.getBankAccounts = this.getBankAccounts.bind(this);
  }

  public componentWillMount() {
    this.fetchPontoEvents(this.pontoEventTypeId);
  }

  public fetchPontoEvents = (eventTypeId) => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        eventTypeId: eventTypeId
      },
      onSuccess: data => {
        const pontoEvents: EventInterface[] = data.events
          .filter((event: EventInterface) => !event.removed);

        this.setState({
          events: [...pontoEvents],
          fetchingEvents: false
        });
      }
    });
  }

  public deleteBankAccount = (bankAccount: BankAccountInterface): any => {
    const numberOfAccounts = this.getAgencyBankAccounts()?.length;
    if (numberOfAccounts === 1) {
      this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans("bank_account_minimum_amount_error"),
          type: "error"
        }
      });
      return;
    }
    this.props.dispatch({
      type: Constants.GLOBAL_BANK_ACCOUNT_DELETE_START,
      payload: {
        bankAccount: bankAccount
      },
      onSuccess: () => this.setState({ isDeleteBankAccountPopupOpen: false })
    });
  }

  protected openMenu = (event: any, bankAccount: BankAccountInterface): void => {
    this.selectedBankAccount = bankAccount;

    this.setState({
      anchorEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null
    });
  }

  public getBankAccounts(): any {
    return this.getAgencyBankAccounts()
      .sort((bankAccount1: BankAccountInterface, bankAccount2: BankAccountInterface) => {
        if (bankAccount1.name.toLowerCase() > bankAccount2.name.toLowerCase()) {
          return 1;
        }

        if (bankAccount1.name.toLowerCase() < bankAccount2.name.toLowerCase()) {
          return -1;
        }

        return  0;
      })
      .map((bankAccount: BankAccountInterface, key: number) => {
        return (
          <TableRow 
            hover 
            key={`bankAccount-${key}`} 
            className={`clickable-entity`}
            onClick={() => this.setState({currentBankAccount: bankAccount, anchorEl: null}, () => this.setState({isUpdating: true, isDialogOpen: true}))}
          >
            <TableCell></TableCell>
            <TableCell style={{width: "25%"}}>{bankAccount.label}</TableCell>
            <TableCell style={{width: "30%"}}>{bankAccount.accountId}</TableCell>
            <TableCell style={{width: "25%"}}>{bankAccount.name}</TableCell>
            <TableCell style={{width: "10%"}}>{bankAccount.isDefault ? this.trans("label-yes") : ""}</TableCell>
            <TableCell
              style={{width: "10"}}
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openMenu(e, bankAccount)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorEl}
                  open={Boolean(this.state.anchorEl) && this.selectedBankAccount && this.selectedBankAccount.id === bankAccount.id}
                  onClose={this.closeMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={() => this.setState({currentBankAccount: this.selectedBankAccount, anchorEl: null}, () => this.setState({isUpdating: true, isDialogOpen: true}))}
                  >
                    <ListItemIcon><div className="icon icon-ic-edit aligned"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    className="delete-action"
                    onClick={() => this.setState({isDeleteBankAccountPopupOpen: true, currentBankAccount: this.selectedBankAccount, anchorEl: null})}
                  >
                    <ListItemIcon><div className="icon icon-ic-remove aligned"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public checkDefaultBankAccount = (updatedBankAccount: BankAccountInterface) => {
    const defaultBankAccount = this.getAgencyBankAccounts()?.filter(bankAccount => bankAccount?.isDefault)?.[0];
    // If user change the default bank account,
    // We have to inform user to disconnect the old bank account from ponto.
    if (
      defaultBankAccount &&
      defaultBankAccount?.id !== updatedBankAccount?.id &&
      defaultBankAccount?.pontoIntegration?.isConnected &&
      updatedBankAccount.isDefault
      ) {
      return this.setState({
        showPontoDialog: true
      });
    }
    this.saveBankAccount(updatedBankAccount);
  }

  public saveBankAccount = (updatedBankAccount: BankAccountInterface): any => {
    this.props.dispatch({
      type: Constants.GLOBAL_BANK_ACCOUNT_UPDATE_START,
      payload: {
        bankAccount: {...updatedBankAccount}
      },
      onSuccess: this.closeDialog,
    });
  }

  public addBankAccount = (bankAccount): any => {
    const defaultBankAccount = this.getAgencyBankAccounts()?.filter(bankAccount => bankAccount?.isDefault)?.[0];
    // Check if there are any default bank accounts that are connected to ponto.
    if (
      defaultBankAccount &&
      defaultBankAccount?.pontoIntegration?.isConnected &&
      bankAccount.isDefault
    ) {
      return this.setState({
        showPontoDialog: true
      });
    }

    this.props.dispatch({
      type: Constants.GLOBAL_BANK_ACCOUNT_CREATE_START,
      payload: {
        bankAccount: bankAccount
      },
      onSuccess: this.closeDialog
    });
  }

  public closeDialog = () => {
    this.setState({
      isDialogOpen: false,
      isUpdating: false,
      currentBankAccount: null
    });

    this.props.dispatch({
      type: Constants.GLOBAL_BANK_ACCOUNT_UPDATE_CLEAR,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_BANK_ACCOUNT_CREATE_CLEAR,
    });
  }

  public getDialogContent(): any {
    if (this.state.isUpdating) {
      return (
        <BankAccountUpdate
          {...this.props}
          bankAccount={this.state.currentBankAccount}
          onSave={this.checkDefaultBankAccount}
          onClose={this.closeDialog}
        />
      );
    }

    return (
      <BankAccountCreate
        {...this.props}
        onSave={this.addBankAccount}
        onClose={this.closeDialog}
        bankAccounts={this.getAgencyBankAccounts()}
      />
    );
  }

  public render() {
    return (
      <div style={{width: "100%"}}>
        <div className="component-wrapper no-margin-top no-margin-right">
          <Card className="card no-padding">
            <div className="label-container" style={{display: "flex", justifyContent: "space-between", alignItems: "baseline"}}>
              <div style={{flexDirection: "column"}}>
                <h3 className="card-title">
                  {this.trans("bank-accounts")}
                </h3>
                <p
                  className="hint-styles"
                  style={{margin: "0px 0px 10px 65px"}}
                >
                  {this.trans("bank-accounts-subtitle")}
                </p>
              </div>
              <div className="button-container">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => this.setState({isDialogOpen: true})}
                  style={{marginRight: "25px"}}
                >
                  {this.trans("add-bank-account")}
                </Button>
              </div>
            </div>
            <div className="table-container">
              <TableComponent
                {...this.props}
                dispatch={this.props.dispatch}
                headers={[
                  "", this.trans("label-name"), this.trans("label-bank-account"), this.trans("list-label-bank-account-name"), this.trans("default"), ""
                ]}
                entities={this.props.app.bankAccounts}
                className="listing-table bank-accounts-listing-table"
                rows={this.getBankAccounts()}
              />
            </div>
            {/* {this.isBeta() && 
              <Timeline
                {...this.props}
                // relations={{ contactId: this.state.person && this.state.person.id }}
                entityEvents={this.state.events}
                fetchEntityEvents={this.fetchPontoEvents.bind(this, this.pontoEventTypeId)}
                fetchingEvents={this.state.fetchingEvents}
              />
            } */}
          </Card>
        </div>

        <PromptDialog
          {...this.props}
          title={this.trans("title-bank-account")}
          content={this.getDialogContent()}
          openLeavePrompt={this.state.isDialogOpen}
          onClose={this.closeDialog}
          onlyPositiveButton={false}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("dialog/attention-title") + "!"}
          content={this.trans("please_disconnect_from_ponto")}
          openLeavePrompt={this.state.showPontoDialog}
          onClose={() => this.setState({
            showPontoDialog: false
          })}
          onlyPositiveButton={true}
          prioritizeClosing={true}
          positiveButtonLabel={this.trans("button-close")}
          onSave={() => this.setState({
              showPontoDialog: false
            })
          }
        />

        <PromptDialog
          title={this.trans("delete-bank-account")}
          content={this.trans("you-are-about-to-delete-bank-account",
            {
              name: this.state.currentBankAccount && this.state.currentBankAccount.name ? this.state.currentBankAccount.name : "",
              number: this.state.currentBankAccount && this.state.currentBankAccount.accountId ? this.state.currentBankAccount.accountId : "",
            })
          }
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-remove")}
          openLeavePrompt={this.state.isDeleteBankAccountPopupOpen}
          prioritizeClosing={true}
          onDiscard={() => { this.setState({ isDeleteBankAccountPopupOpen: false }); }}
          onSave={() => { this.setState({ isDeleteBankAccountPopupOpen: false }, this.deleteBankAccount(this.state.currentBankAccount)); }}
          positiveButtonStyle={{backgroundColor:"red"}}
          hideCross={true}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    component: state.bankAccountCreate,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
    BankAccounts
);
